import { Box, Button, Center, Flex, Portal, Text } from '@chakra-ui/react';
import PillarsApp from './PillarApp';

const RespondentViewThemes = ({ surveyId, onClose, companyId, pillarId, userId, pillar, pillarIndex }) => {
 return (
  <Portal>
   <Box
    position='fixed'
    top={0}
    left={0}
    right={0}
    bottom={0}
    zIndex={9999}
    bg='white'
    overflowY='auto'
    css={{
     '&::-webkit-scrollbar': {
      width: '8px',
     },
     '&::-webkit-scrollbar-track': {
      width: '10px',
     },
     '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: '24px',
     },
    }}
   >
    <Box position='fixed' top={0} left={0} right={0} zIndex={10000} h='44px' bg='#FBDED5'>
     <Center h='100%' px='86px'>
      <Flex w='100%' maxW='1280px' justify='space-between' align='center'>
       <Text fontSize='sm' color='#EA582B' fontWeight='500'>
        <b>Atenção:</b> Você está no modo visualização do respondente. Neste modo, nenhuma
        ação é permitida.
       </Text>
       <Button
        variant='link'
        color='#EA582B'
        fontSize='15px'
        textDecor='underline'
        fontWeight='600'
        onClick={onClose}
        _hover={{ textDecor: 'underline' }}
       >
        Sair do modo visualização
       </Button>
      </Flex>
     </Center>
    </Box>

    <PillarsApp
     surveyId={surveyId}
     companyId={companyId}
     pillarId={pillarId}
     userId={userId}
     pillar={pillar}
    pillarIndex={pillarIndex}
    />
   </Box>
  </Portal>
 );
};

export default RespondentViewThemes;
